//css-------------------
import '../../css/share/common.scss';
import '../../css/home/article_summary.scss';


//fontawesome
import( /* webpackPrefetch: true */ '../../lib/fontawesome/css/fontawesome.css');
import( /* webpackPrefetch: true */ '../../lib/fontawesome/css/regular.css');
import( /* webpackPrefetch: true */ '../../lib/fontawesome/css/brands.css');
import( /* webpackPrefetch: true */ '../../lib/fontawesome/css/solid.css');

//js----------------------
//components
import( /* webpackPrefetch: true */ '../share/components/_common');
import( /* webpackPrefetch: true */ '../share/components/_list_swiper');
import( /* webpackPrefetch: true */ '../share/components/_fontSize');


$(function () {

    let _arti_id;

    $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });

    $('.button_download').click(function () {
        _arti_id = $(this).data('id');
        $.ajax({
            data: {
                arti_id: _arti_id,
            },
            type: 'POST',
            url: '/ajax/count_download',
        }).always(function (response, status) {
            console.log(response, status);
        });
    });

});